module.exports = __webpack_public_path__ + "img/route-interstate.18004d04.svg";